// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_25d90","icon":"index_icon_1Gx4f"};